import { List } from 'immutable';
import { createSelector, defaultMemoize } from 'reselect';

import { isResourceComplete, isResourceLoading } from './common';

const isWebinarsLoading = defaultMemoize(isResourceLoading);

const getWebinars = defaultMemoize((data) => data.get('webinars', List()));

const getWebinarData = (state) => state.getIn(['app', 'training']);
const isWebinarLoaded = createSelector(getWebinarData, isResourceComplete);
const getWebinarTitle = createSelector(getWebinarData, (data) => data.getIn(['webinar', 'title']));

export {
    isWebinarLoaded,
    isWebinarsLoading,
    getWebinars,
    getWebinarTitle,
};
